// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2UTYv","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1RjdC"};